export default __webpack_public_path__ + "static/media/team5.2c218058.png";